import { Routes, Route, useLocation, useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import PayslipPage from './pages/PayslipPage';
import InstuctionsPage from './pages/InstructionsPage';
import LoggedOutPage from './pages/LoggedOutPage';
import NotFoundPage from './pages/NotFoundPage';
import NavBar from './components/NavBar';


export default function AppContent(){
  const [menuOpen, setMenuOpen] = useState(null);

  const location = useLocation();
  const [searchParams] = useSearchParams();
  const modalOpen = searchParams.get("modal");

  const anyOpen = menuOpen || modalOpen;

  useEffect(() => {
    document.documentElement.classList.toggle("disableScrolling", anyOpen);
  },[anyOpen]);

  // Add class for accessibility
  useEffect(() => {
    function handleKeyDown(e){
      if(e.key === "Tab"){
        document.documentElement.classList.add("keyboardNavigation");
      }
    }
    function handleMouseDown(){
      document.documentElement.classList.remove("keyboardNavigation");
    }

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("mousedown", handleMouseDown);

    return () =>{
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("mousedown", handleMouseDown);
    };
  },[]);

  useEffect(() => {
    setMenuOpen(null);
  },[location.pathname]);

  useEffect(() => {
    const handlePopState = () => {
      if(menuOpen){
        setMenuOpen(null);
      }
    };
    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  },[menuOpen]);

  // Check for touch devices (Tablet/Mobile)
  /*const isTouchDevice= (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) || 'ontouchstart' in window;

  if(isTouchDevice){
    document.documentElement.classList.add('touchDevice'); // Add class to html
  }else{
    document.documentElement.classList.remove('touchDevice');
  }

  useEffect(() =>{
    function checkTouch(){
      const isTouchDevice =
        (navigator.maxTouchPoints && navigator.maxTouchPoints > 0) ||
        "ontouchstart" in window;
      document.documentElement.classList.toggle("touchDevice", isTouchDevice);
    }

    checkTouch();
    window.addEventListener("resize", checkTouch);

    return () => window.removeEventListener("resize", checkTouch);
  },[]);*/
  
  return(
    <>
      <NavBar
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />
      <Routes>
        <Route index path="/laskelma/*" element={
          <PayslipPage
            modalOpen={modalOpen}
          />
        }
        />
        <Route path="/instructions" element={<InstuctionsPage />} />
        <Route path="/logout" element={<LoggedOutPage />} />
        <Route path="/*" element={<NotFoundPage />} />
      </Routes>
    </>
  );
}
